var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtensiveLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.608 55.0116H24.7784V58.1736C24.7784 62.6547 26.7045 65 30.4034 65H55.375C59.0568 65 61 62.6547 61 58.1736V36.7939C61 32.3127 59.0568 29.9674 55.375 29.9674H52.2045V26.8264C52.2045 22.3453 50.2784 20 46.5966 20H21.608C17.9091 20 16 22.3453 16 26.8264V48.1852C16 52.6873 17.9091 55.0116 21.608 55.0116ZM21.8295 50.8446C20.2614 50.8446 19.392 49.8395 19.392 47.8083V27.2034C19.392 25.1722 20.2614 24.188 21.8295 24.188H46.375C47.9261 24.188 48.8125 25.1722 48.8125 27.2034V29.9674H30.4034C26.7045 29.9674 24.7784 32.3127 24.7784 36.7939V50.8446H21.8295ZM30.625 60.812C29.0398 60.812 28.1875 59.8069 28.1875 57.7966V37.1708C28.1875 35.1605 29.0398 34.1554 30.625 34.1554H55.1534C56.7216 34.1554 57.5909 35.1605 57.5909 37.1708V57.7966C57.5909 59.8069 56.7216 60.812 55.1534 60.812H30.625Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensiveLibrary);
export default __webpack_public_path__ + "static/media/Extensive Library.039681019e15d7e22ff4ae201b6abf74.svg";
export { ForwardRef as ReactComponent };